module.exports = __webpack_public_path__ + "img/copy.cbad8189.svg";